import { Dialog } from "@progress/kendo-react-dialogs";
import { Checkbox } from "@progress/kendo-react-inputs";
import React, { useEffect, useState } from "react";
import { NotificationManager } from "react-notifications";
import DatePickerKendoRct from "../../../control-components/date-picker/date-picker";
import TextAreaKendoRct from "../../../control-components/kendo-text-area/kendo-text-area";
import Loader from "../../../control-components/loader/loader";
import ErrorHelper from "../../../helper/error-helper";
import { TaskService } from "../../../services/taskService";
import { showError } from "../../../util/utility";
import { renderErrors } from "src/helper/error-message-helper";
import { API_ENDPOINTS } from "src/services/api-endpoints";
import DateTimeHelper from "src/helper/date-time-helper";


import calenderIcon from "../../../assets/images/calendar-03.png"
import { customAxios } from "src/services/useExPressApi";
const AddDocumentTask = ({ onClose, task, documentId, authorStaffId , taskAdded}) => {
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState("");
  const [settingError, setSettingError] = useState(false);

  const [fields, setFields] = useState({
    taskDescription: "",
    dueDate: "",
    isHighPriorityTask: false,
  });

  useEffect(() => {
    if (task) {
      getTaskDetail();
    }
  }, [task]);

  useEffect(() => {
    let errors = {};

    if (!fields.taskDescription) {
      errors.taskDescription = ErrorHelper.FIELD_BLANK;
    }

    setErrors(errors);
  }, [fields]);

  const getTaskDetail = () => {
    setLoading(true);
    TaskService.getTaskDetail(task.id)
      .then((result) => {
        let data = result.resultData;
        setFields({
          ...fields,
          taskDescription: data.taskDescription,
          dueDate: data.dueDate ? new Date(data.dueDate) : "",
          isHighPriorityTask: data.isHighPriorityTask,
        });
      })
      .catch((error) => {
        renderErrors(error.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setFields({
      ...fields,
      [name]: value,
    });
  };

  const handleTextChange = (e) => {
    const name = e.target.name;
    const value = e.value;
    setFields({
      ...fields,
      [name]: value,
    });
  };

  const saveTask = () => {
    const body = {
      ...fields,
      documentId,
      staffIds: [authorStaffId],
      dueDate: fields.dueDate ? DateTimeHelper.format(fields.dueDate, "YYYY-MM-DD") : "",
    };

    setLoading(true);
    customAxios.post(API_ENDPOINTS.INSERT_TASK, body)
      .then((result) => {
        NotificationManager.success("Task added successfully");
        onClose(true);
        taskAdded({added:true})
      })
      .catch((error) => {
        renderErrors(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const updateTask = () => {
    const body = {
      ...fields,
      id: task.id,
      documentId,
      staffIds: [authorStaffId],
      dueDate: fields.dueDate ? DateTimeHelper.format(fields.dueDate, "YYYY-MM-DD") : "",
    };

    setLoading(true);
    customAxios.put(API_ENDPOINTS.UPDATE_TASK, body)
      .then((result) => {
        NotificationManager.success("Task updated successfully");
        onClose(true);
      })
      .catch((error) => {
        showError(error, "Task Update");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleSubmit = () => {
    if (Object.keys(errors).length > 0) {
      setSettingError(true);
      return;
    }

    if (task) {
      updateTask();
    } else {
      saveTask();
    }
  };

  const handleClose = () => {
    onClose(false)
  }

  return (
    <Dialog
      onClose={handleClose}
      title={task ? "Update task" : "Add Task"}
      className="small-dailog medium-modal width_90 blue_theme" width={"50%"} height={"65%"}
    >
      <div className="Service-accept edit-Service-popup">
        <div className="px-2 py-3">
          <div className="col-md-12 col-lg-12 col-12 mb-4">
            <TextAreaKendoRct
              name="taskDescription"
              txtValue={fields.taskDescription}
              onChange={handleTextChange}
              label="Task"
              placeholder={"Enter your task description..."}
              error={
                settingError &&
                !fields.taskDescription &&
                errors.taskDescription
              }
              required={settingError}
            />
          </div>
          <div className="col-md-12 col-lg-12 col-12 mb-4 position-relative">
            <DatePickerKendoRct
              onChange={handleChange}
              placeholder="Due date"
              name={"dueDate"}
              label={"Due date"}
              value={fields.dueDate}
            />
                <img src={calenderIcon} className="blueThemeIcons" alt="calender"/>
          </div>
          <div className="col-md-12 col-lg-12 col-12 mb-4">
            <Checkbox
              onChange={handleChange}
              label={"Is Important"}
              name="isHighPriorityTask"
              value={fields.isHighPriorityTask}
            />
          </div>
        </div>
        {loading == true && <Loader />}
        
        <div className="row  preview-btn-bottom m-0 justify-content-end ">
          <div className="d-flex justify-content-end buttonWidth">
            <div>
              <button
                onClick={handleSubmit}
                className="submitButon ml-2"
              >
                Save
              </button>
            </div>
            <div>
              <button
                className="cancelBtn mr-4"
                onClick={handleClose}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default AddDocumentTask;
